import { Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import {
  SERVICE_TYPE,
  TServiceDealType,
  TServiceType,
} from "../../../../api/service/service.types";
import cuideoTheme from "../../../../containers/themes/defaultTheme";
import {
  TIPO_TRATO_INTERNA_ENTRE_SEMANA,
  TIPO_TRATO_INTERNA_ENTRE_SEMANA_SIN_SUST,
  TIPO_TRATO_INTERNA_FIN_DE_SEMANA,
  TIPO_TRATO_INTERNA_FIN_DE_SEMANA_SIN_SUST,
  TIPO_TRATO_EXTERNA_MAS_20_HORAS,
  TIPO_TRATO_EXTERNA_MAS_20_HORAS_SIN_SUST,
  TIPO_TRATO_EXTERNA_MENOS_20_HORAS,
  TIPO_TRATO_EXTERNA_MENOS_20_HORAS_SIN_SUST,
  TIPO_TRATO_PROFESIONAL_POR_HORAS,
} from "../../../../util/defaults/contrato";

const StyledType = styled(Typography)<{ type: string }>`
  color: ${cuideoTheme.palette.primary.main};
  font-size: 0.75rem;
  letter-spacing: 0.0625rem;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;

  ${({ type }) => {
    if (type === SERVICE_TYPE.CUIDEO_ASIST) {
      return `
        &:after {
          display: block;
          height: 0.25rem;
          width: 2rem;
          background-color: #fbb7c3;
          content: ' ';
          margin: 0.125rem 0 0.25rem;
        }
      `;
    }
    if (
      type === TIPO_TRATO_INTERNA_ENTRE_SEMANA ||
      type === TIPO_TRATO_INTERNA_ENTRE_SEMANA_SIN_SUST
    ) {
      return `
        &:after {
          display: block;
          height: 0.25rem;
          width: 2rem;
          background-color: #fbb7c3;
          content: ' ';
          margin: 0.125rem 0 0.25rem;
        }
      `;
    }
    if (
      type === TIPO_TRATO_INTERNA_FIN_DE_SEMANA ||
      type === TIPO_TRATO_INTERNA_FIN_DE_SEMANA_SIN_SUST
    ) {
      return `
        &:after {
          display: block;
          height: 0.25rem;
          width: 2rem;
          background-color: rgba(126, 211, 33, 0.3);
          content: ' ';
          margin: 0.125rem 0 0.25rem;
        }
      `;
    }
    if (
      type === TIPO_TRATO_EXTERNA_MAS_20_HORAS ||
      type === TIPO_TRATO_EXTERNA_MAS_20_HORAS_SIN_SUST
    ) {
      return `
        &:after {
          display: block;
          height: 0.25rem;
          width: 2rem;
          background-color: rgba(144, 19, 254, 0.3);
          content: ' ';
          margin: 0.125rem 0 0.25rem;
        }
      `;
    }
    if (
      type === TIPO_TRATO_EXTERNA_MENOS_20_HORAS ||
      type === TIPO_TRATO_EXTERNA_MENOS_20_HORAS_SIN_SUST ||
      type === TIPO_TRATO_PROFESIONAL_POR_HORAS
    ) {
      return `
        &:after {
          display: block;
          height: 0.25rem;
          width: 2rem;
          background-color: rgba(245, 166, 35, 0.3);
          content: ' ';
          margin: 0.125rem 0 0.25rem;
        }
      `;
    }
    return ``;
  }}
`;

interface IServiceTypeProps {
  serviceType?: TServiceType;
  serviceDealType?: TServiceDealType;
}

const ServiceType = (props: IServiceTypeProps) => {
  const { serviceType, serviceDealType } = props;

  const type =
    serviceType === SERVICE_TYPE.CUIDEO_ASIST ||
    serviceType === SERVICE_TYPE.HOURLY_PROFESSIONAL
      ? serviceType
      : serviceDealType ?? SERVICE_TYPE.SELECTION;

  return <StyledType type={type}>{type}</StyledType>;
};

export default ServiceType;
